// extracted by mini-css-extract-plugin
export default {"orderDetails":"OrderPage_orderDetails__GEDIu","orderDetails__container":"OrderPage_orderDetails__container__S1Yjd"};